module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Dein Warenkorb"},"en":{"title":"Your Cart"},"es":{"title":"Tu compra"},"fr":{"title":"Votre panier"},"it":{"title":"Il tuo carrello"},"ja":{"title":"ご注文内容"},"pt":{"title":"O teu carrinho"}}')
  delete Component.options._Ctor
}
